import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  constructor(private http: HttpClient) {}

  ControllerLookup = 'Lookup'
  ControllerRiskCategory = 'RiskCategory'
  ControllerRiskEventSource = 'RiskEventSource'
  ControllerControl = 'Control'
  ControllerAsset = 'Asset'
  ControllerUser = 'User'
  ControllerThreat = 'Threat'
  ControllerThreatCategory = 'ThreatCategory'
  ControllerAssetCategory = 'AssetCategory'
  ControllerAssetLocation = 'AssetLocation'
  ControllerControlCategory = 'ControlCategory'
  ControllerVulnerabilityCategories = 'VulnerabilityCategory'
  ControllerPackage = 'Package'
  MaturityControllerPackage = 'MaturityPackage'
  ControllerOwnershipTypes = 'OwnershipTypes'
  ControllerApprovalCyclePlan = 'ApprovalCyclePlan'
  ControllerEvent = 'Event'
  ControllerDocumentType = 'DocumentType'
  ControllerDocumentStatuses = 'DocumentStatuses'
  ControllerDocument = 'Document'
  ControllerDashboard = 'Dashboard'
  MaturityControllerDashboard = 'MaturityDashboard'
  ControllerRole = 'Role'
  // private packagesCacheMap = new Map<string, Observable<any>>()

  // Control/GetControlLookup
  getTypesLookup(keyword: string = '') {
    return this.http.get('FunctionType', { params: { search: keyword } })
  }

  // getFuntionsLookups(keyword: string = '') {
  //   return this.http.get('Company', { params: { search: keyword } });
  // }
  getFuntionsLookups(keyword: string = '', excludeId?: string) {
    const params: any = { search: keyword }

    if (excludeId) {
      params.excludeId = excludeId
    }

    return this.http.get(`Company`, { params })
  }

  getRolesLookup(keyword: string = '') {
    return this.http.get(`${this.ControllerRole}/GetRoles`, {
      params: { search: keyword }
    })
  }
  // getUsersList(companyId?: string) {
  //   const params = companyId ? { params: { companyId: companyId } } : {};
  //   return this.http.get(`User/GetUsers`, params);
  // }
  geOwnersLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerLookup}/Owners`, {
      params: { search: keyword }
    })
  }
  getRiskCategoryLookup(keyword: string = '') {
    return this.http.get(`${this.ControllerRiskCategory}/GetRiskCategories`, {
      params: { search: keyword }
    })
  }
  getRiskEventSourceLookup(keyword: string = '') {
    return this.http.get(
      `${this.ControllerRiskEventSource}/GetRiskEventSources`,
      { params: { search: keyword } }
    )
  }
  getControlsLookup(keyword: string = '') {
    return this.http.get(`${this.ControllerControl}/GetControlLookup`, {
      params: { search: keyword }
    })
  }

  getAssetsLookup(keyword: string = '', excludeId: string = '') {
    return this.http.get(`${this.ControllerAsset}/GetAssetLookup`, {
      params: { search: keyword, excludeId: excludeId }
    })
  }

  getAssetsCategoriesLookup(keyword: string = '') {
    return this.http.get(`${this.ControllerAssetCategory}/GetAssetCategories`, {
      params: { search: keyword }
    })
  }

  getControlCategoriesLookup(keyword: string = '') {
    return this.http.get(
      `${this.ControllerControlCategory}/GetControlCategories`,
      { params: { search: keyword } }
    )
  }
  getVulnerabilityCategoriesLookup(keyword: string = '') {
    return this.http.get(
      `${this.ControllerVulnerabilityCategories}/GetVulnerabilityCategories`,
      {
        params: { search: keyword }
      }
    )
  }

  getAssetsLocationLookup(keyword: string = '') {
    return this.http.get(`${this.ControllerAssetLocation}/GetAssetLocations`, {
      params: { search: keyword }
    })
  }
  getThreatLookup(keyword: string = '') {
    return this.http.get(`${this.ControllerThreat}/GetThreatLookup`, {
      params: { search: keyword }
    })
  }
  getThreatCategoryLookup(keyword: string = '') {
    return this.http.get(
      `${this.ControllerThreatCategory}/GetThreatCategories`,
      { params: { search: keyword } }
    )
  }
  getUserLookup(keyword: string = '', companyId?: string) {
    const params: any = {}

    if (companyId) {
      params.companyId = companyId
    }

    if (keyword) {
      params.search = keyword
    }

    return this.http.get(`User/GetUsers`, { params })
  }

  // for compliance module
  getMeasurementMethodsLookupForCompliance() {
    return this.http.get(`${this.ControllerLookup}/MeasurementMethods`)
  }
  getMeasurementMethodDashboardLookupForCompliance() {
    return this.http.get(`${this.ControllerDashboard}/MeasurementMethods`)
  }

  // for maturity module
  getMeasurementMethodsLookupForMaturity() {
    return this.http.get(`${this.ControllerLookup}/MaturityMeasurementMethods`)
  }
  getMeasurementMethodDashboardLookupForMaturity() {
    return this.http.get(
      `${this.MaturityControllerDashboard}/MeasurementMethods`
    )
  }

  // for compliance module
  getAssessmentTargetsLookupForCompliance(measurementMethodId: string) {
    const queryId = measurementMethodId != null ? measurementMethodId : ''
    return this.http.get(
      `${this.ControllerLookup}/AssessmentTargets/${queryId}`
    )
  }

  // for maturity module
  getAssessmentTargetsLookupForMaturity(measurementMethodId: string) {
    const queryId = measurementMethodId != null ? measurementMethodId : ''
    return this.http.get(
      `${this.ControllerLookup}/MaturityAssessmentTargets/${queryId}`
    )
  }

  // for compliance module
  getResultsLookupsForCompliance(
    keyword: string = '',
    measurementMethodId: any
  ) {
    return this.http.get(`${this.ControllerLookup}/AssessResults`, {
      params: { search: keyword, measurementMethodId: measurementMethodId }
    })
  }
  // for maturity module
  getResultsLookupsForMaturity(keyword: string = '', measurementMethodId: any) {
    return this.http.get(`${this.ControllerLookup}/MaturityAssessResults`, {
      params: { search: keyword, measurementMethodId: measurementMethodId }
    })
  }

  getPackagesLookupForCompliance(keyword: string = ''): Observable<any> {
    // if (!this.packagesCacheMap.has(keyword)) {
    //   const request$ = this.http
    //     .get(`${this.ControllerPackage}/GetPackages`, {
    //       params: { search: keyword }
    //     })
    //     .pipe(shareReplay(1))

    //   this.packagesCacheMap.set(keyword, request$)
    // }

    // return this.packagesCacheMap.get(keyword)!
    return this.http.get(`${this.ControllerPackage}/GetPackages`, {
      params: { search: keyword }
    })
  }
  getAssesedPackagesLookupForCompliance(keyword: string = ''): Observable<any> {
    return this.http.get(`${this.ControllerDashboard}/Packages`, {
      params: { search: keyword }
    })
  }

  getPackagesLookupForMaturity(keyword: string = ''): Observable<any> {
    // if (!this.packagesCacheMap.has(keyword)) {
    //   const request$ = this.http
    //     .get(`${this.MaturityControllerPackage}/GetPackages`, {
    //       params: { search: keyword }
    //     })
    //     .pipe(shareReplay(1))

    //   this.packagesCacheMap.set(keyword, request$)
    // }

    // return this.packagesCacheMap.get(keyword)!
    return this.http.get(`${this.MaturityControllerPackage}/GetPackages`, {
      params: { search: keyword }
    })
  }

  getAssesedPackagesLookupForMaturity(keyword: string = ''): Observable<any> {
    return this.http.get(`${this.MaturityControllerDashboard}/Packages`, {
      params: { search: keyword }
    })
  }

  getStatussLookup() {
    return this.http.get(`${this.ControllerLookup}/PackageStatuses`)
  }

  getOwnershipTypesLookups() {
    return this.http.get(`${this.ControllerLookup}/OwnershipTypes`)
  }

  getFrequencyTypesLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerLookup}/FrequencyTypes`, {
      params: { search: keyword }
    })
  }
  getPlansLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerApprovalCyclePlan}/GetPlans`, {
      params: { search: keyword }
    })
  }
  getEventsLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerEvent}/GetEvents`, {
      params: { search: keyword }
    })
  }
  getDocumentTypesLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerDocumentType}/GetTypes`, {
      params: { search: keyword }
    })
  }
  getLinkedDocumentLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerDocument}/GetDocuments`, {
      params: { search: keyword }
    })
  }
  getDocumentStatusesLookups() {
    return this.http.get(`${this.ControllerLookup}/DocumentStatuses`)
  }
  getAssessmentStatusesLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerLookup}/AssessmentStatuses`, {
      params: { search: keyword }
    })
  }
  getThreatActorsLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerLookup}/ThreatActors`, {
      params: { search: keyword }
    })
  }
  getTreatmentRolesLookups(keyword: string = '') {
    return this.http.get(`${this.ControllerLookup}/TreatmentRoles`, {
      params: { search: keyword }
    })
  }
  getRiskStatusesLookup() {
    return this.http.get(`${this.ControllerLookup}/RiskStatuses`)
  }
}
